import { render, staticRenderFns } from "./transactionHistory.vue?vue&type=template&id=20b9f6b5"
import script from "./transactionHistory.vue?vue&type=script&lang=js"
export * from "./transactionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports